/* eslint-disable react/jsx-wrap-multilines */
import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  InputHTMLAttributes,
  useMemo,
} from 'react';

import { useField } from '@unform/core';
import { Col, Row } from 'react-bootstrap';
import Checkbox from '../../../../../components/Exame/CheckBox';
import { useToast } from '../../../../../hooks/toast';
import Loading from '../../../../../components/Loading';
import CardCadastro from '../CardCadastro';
import { IParcela } from '..';
import { formatPrice } from '../../../../../utils/funcoes';

interface DivProps extends InputHTMLAttributes<HTMLDivElement> {
  name: string;
  parcelas: IParcela[];
}

const Parcelas: React.FC<DivProps> = ({ name, parcelas, ...rest }) => {
  const checkRef = useRef(null);
  const { fieldName, defaultValue, registerField } = useField(name);
  const [checkedItems, setCheckedItems] = useState<string>('');
  const [itens, setItens] = useState<IParcela[]>([]);
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setItens(parcelas);
  }, [parcelas]);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: checkRef.current,
      path: 'value',
      clearValue: ref => {
        ref.clear();
      },
      setValue: (ref, valord) => {
        // setCheckedItems(valord);
      },
    });
  }, [checkedItems, fieldName, registerField, itens]);

  useEffect(() => {
    const its = itens
      .filter(item => {
        return item.selecionado;
      })
      .map(i => i.CprCodigo)
      .join('-');

    setCheckedItems(its);
  }, [itens]);

  const total = useMemo(() => {
    const selecionados = itens.filter(it => it.selecionado);
    const valor = selecionados.reduce((tot, it) => {
      return tot + Number(it.CprValor);
    }, 0);

    return { valor: formatPrice(valor), qtd: selecionados.length };
  }, [itens]);

  const handleChange = useCallback(
    e => {
      const cprCodigo = e.target.name;
      const isChecked = e.target.checked;

      const newItens = itens.map(it => {
        if (it.CprCodigo?.toString() === cprCodigo)
          return { ...it, selecionado: isChecked };
        return it;
      });

      const its = newItens
        .filter(item => {
          return item.selecionado;
        })
        .map(i => i.CprCodigo)
        .join('-');

      setCheckedItems(its);

      setItens(newItens);
    },
    [itens],
  );

  return (
    <>
      {loading && <Loading backgroundBlack={false} />}

      <input
        className="d-none"
        value={checkedItems}
        onChange={() => console.log(itens)}
        ref={checkRef}
      />

      <Row>
        <Col>
          <CardCadastro
            title="PARCELAS EM ATRASO"
            footer={
              <>
                <div style={{ justifyContent: 'right', display: 'flex' }}>
                  <span>
                    quantidade: <b>{total.qtd}</b>
                  </span>
                  <span style={{ marginLeft: '30px' }}>
                    total: <b>{total.valor}</b>
                  </span>
                </div>
              </>
            }
          >
            <div
              style={{
                maxHeight: '270px',
                overflowY: 'auto',
                margin: '-15px',
              }}
            >
              {itens && itens.length > 0 && (
                <table
                  className="table table-hover table-sm small"
                  cellSpacing="0"
                  cellPadding="4"
                  style={{
                    borderCollapse: 'collapse',
                    fontFamily: 'verdana',
                  }}
                >
                  <tbody>
                    <tr className="bg-light text-info small">
                      <th scope="col">Histórico</th>
                      <th scope="col">Data Venc.</th>
                      <th scope="col">Valor</th>
                    </tr>
                    {itens.map(item => (
                      <tr
                        key={`cobItem-${item.CprCodigo}`}
                        style={{ fontSize: 'Smaller' }}
                      >
                        <td>{item.CprHistorico}</td>
                        <td>{item.dataVencFormatada}</td>
                        <td>{item.valorFormatado}</td>
                        <td>
                          <Checkbox
                            name={item.CprCodigo?.toString() || ''}
                            checked={item.selecionado}
                            onChange={handleChange}
                          />
                        </td>
                      </tr>
                    ))}
                    {/* <tr key="cobItem-total" style={{ fontSize: 'Smaller' }}>
                      <td />
                      <td>
                        <b>Total:</b>
                      </td>
                      <td>{total.valor}</td>
                      <td style={{ width: '110px' }}>{total.qtd}</td>
                    </tr> */}
                  </tbody>
                </table>
              )}
            </div>
          </CardCadastro>
        </Col>
      </Row>
    </>
  );
};

export default Parcelas;
